import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Lottie from 'lottie-react';
import { ArrowRight } from 'lucide-react';
import { AuthLayout } from '../../../components/layouts';
import successGif from '../../../assets/images/success.json';
import { modalPrimaryBtn, modalSubtitle, modalTitle } from '../../../components/ui/modalDesign';

export default function SuccessPage() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = window.setTimeout(() => {
            navigate('/parent/home', { replace: true });
        }, 1600);
        return () => window.clearTimeout(timer);
    }, [navigate]);

    return (
        <AuthLayout>
            <div className="text-center">
                <div className="mx-auto mb-4 h-[120px] w-[120px] sm:h-[150px] sm:w-[150px]">
                    <Lottie animationData={successGif} />
                </div>
                <h1 className={modalTitle}>Successful!</h1>
                <p className={modalSubtitle}>
                    Your account is ready. Taking you to your dashboard to start enrolling your child…
                </p>
                <Link
                    to="/parent/home"
                    className={`${modalPrimaryBtn} mt-6 inline-flex no-underline`}
                >
                    Proceed to Dashboard
                    <ArrowRight size={16} />
                </Link>
            </div>
        </AuthLayout>
    );
}
